!function (e) {
  "function" != typeof e.matches && (e.matches = e.msMatchesSelector || e.mozMatchesSelector || e.webkitMatchesSelector || function (e) {
    for (var t = this, o = (t.document || t.ownerDocument).querySelectorAll(e), n = 0; o[n] && o[n] !== t;) ++n;
    return Boolean(o[n])
  }), "function" != typeof e.closest && (e.closest = function (e) {
    for (var t = this; t && 1 === t.nodeType;) {
      if (t.matches(e)) return t;
      t = t.parentNode
    }
    return null
  })
}(window.Element.prototype);


document.addEventListener('DOMContentLoaded', function () {
  var modalButtons = document.querySelectorAll('.js-open-modal'),
    overlay = document.querySelector('.js-overlay-modal'),
    closeButtons = document.querySelectorAll('.js-modal-close');

  modalButtons.forEach(function (item) {

    item.addEventListener('click', function (e) {
      e.preventDefault();
      document.body.style.top = document.body.style.top ? document.body.style.top : `-${window.scrollY}px`;
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      var modalId = this.getAttribute('href'),
        modalElem = document.querySelector('.modal[data-modal="' + modalId + '"]');

      modalElem.classList.add('active');
      overlay.classList.add('active');
    });

  });

  closeButtons.forEach(function (item) {

    item.addEventListener('click', function (e) {
      var parentModal = this.closest('.modal');
      const positionScrollY = document.body.style.top ? document.body.style.top : `-${window.scrollY}px`;
      parentModal.classList.remove('active');
      overlay.classList.remove('active');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, parseInt(positionScrollY || '0') * -1);
      document.querySelector('.modal.active')?.classList.remove('active');
      document.querySelector('.modal.modal-thanks.active')?.classList.remove('active');
    });

  });

  document.body.addEventListener('keyup', function (e) {
    var key = e.keyCode;
    const positionScrollY = document.body.style.top ? document.body.style.top : `-${window.scrollY}px`;
    if (key === 27) {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, parseInt(positionScrollY || '0') * -1);
      document.querySelector('.modal.active')?.classList.remove('active');
      document.querySelector('.overlay')?.classList.remove('active');
    }
  }, false);

  overlay.addEventListener('click', function () {
    const positionScrollY = document.body.style.top ? document.body.style.top : `-${window.scrollY}px`;
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, parseInt(positionScrollY || '0') * -1);
    document.querySelector('.modal.active')?.classList.remove('active');
    document.querySelector('.modal.modal-thanks.active')?.classList.remove('active');
    this.classList.remove('active');
  });

});
